import React from 'react';
import useCharity from '../hooks/useCharity';
import Container from './Container';
import formatNumber from '../utils/formatNumber';
import Spinner from './Spinner';

function CharityTotals() {
  const { totalAmount, totalDonations, loading } = useCharity();

  if (loading) {
    return (
      <div className='flex justify-center py-10 bg-dropdown'>
        <Spinner />
      </div>
    );
  }

  return (
    <div className='py-10 bg-dropdown'>
      <Container>
        <div className='flex flex-col space-y-12 md:justify-center md:space-y-0 md:space-x-32 md:flex-row'>
          <div className='flex flex-col items-center md:space-x-8'>
            <div>
              <div className='flex items-end space-x-3'>
                <p className='text-5xl font-bold text-center md:text-7xl md:text-left'>{formatNumber(totalAmount)}</p>
                <img src='/algo-logo.png' alt='Algorand' className='w-8 h-8 md:mb-3' />
              </div>

              <div className='mt-5 md:mt-3'>
                <h2 className='text-xl text-center opacity-75 md:text-left'>Total Raised</h2>
              </div>
            </div>
          </div>

          <div className='flex flex-col items-center md:space-x-8'>
            <div>
              <p className='text-5xl font-bold text-center md:text-7xl md:text-left'>{formatNumber(totalDonations)}</p>

              <div className='mt-5 md:mt-3'>
                <h2 className='text-xl text-center opacity-75 md:text-left'>Total Donations</h2>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default CharityTotals;
